import { MODES_OF_APT } from "@elixir/types";
import { Popover } from "antd";
import dateFormat from "dateformat";
import React from "react";
import { ReactComponent as ClockRegularIcon } from "../../../assets/icons/font-awesome/clock-regular.svg";
import { ReactComponent as EditRegularIcon } from "../../../assets/icons/font-awesome/edit-regular.svg";
import SelectSlot from "../../../molecules/cards/queue/select-slot";
import useQueueStore from "../../../stores/queue-store";
import { isSameDay } from "../../../utils/date-utils";
import { useCreateAptStore } from "@elixir/stores";

const NewAptSelectedTime = () => {
  const selectedSlot = useQueueStore((state) => state.selectedSlot);
  const customSlotDuration = useQueueStore((state) => state.customSlotDuration);
  const showSelectSlot = useQueueStore((state) => state.showSelectSlot);
  const setShowSelectSlot = useQueueStore((state) => state.setShowSelectSlot);
  const selectedDoctor = useCreateAptStore((state) => state.selectedDoctor);
  const selectedClinicId = useCreateAptStore((state) => state.selectedClinic);
  const mode = useQueueStore((state) => state.mode);

  const [currDate, setCurrDate] = React.useState<Date>(() => new Date());
  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrDate(new Date());
    }, 60000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const { timeLabel, isToday } = React.useMemo(() => {
    if (selectedSlot && customSlotDuration) {
      const { startTime } = selectedSlot;
      const startTimeObj = new Date(startTime);

      const isToday = isSameDay(startTimeObj, new Date());
      const dateString = dateFormat(
        startTimeObj,
        `${isToday ? "DDDD" : "dd mmm"} | hh:MM TT`
      );

      return { timeLabel: `${dateString} | ${customSlotDuration}m`, isToday };
    }
    return {
      timeLabel: `Now (${dateFormat(currDate, "hh:MM TT")})`,
      isToday: true,
    };
  }, [currDate, customSlotDuration, selectedSlot]);

  return (
    <div className="dr-flex dr-items-center dr-space-x-16 dr-bg-darwin-touch-neutral-50 dr-p-12">
      <div className="dr-flex dr-items-center dr-space-x-8 dr-min-w-70 dr-text-darwin-touch-neutral-1000">
        <ClockRegularIcon className="dr-w-14 dr-h-14" />
        <div className="TouchCalloutRegular">Slot</div>
      </div>
      <Popover
        open={showSelectSlot}
        onOpenChange={(openValue) => {
          setShowSelectSlot(openValue);
        }}
        style={{ borderRadius: "16px" }}
        content={
          <SelectSlot
            aptData={selectedClinicId ? {
              clinic_id: selectedClinicId
            } :  null as any}
            aptChannel="BOOKED"
            onSubmitClick={() => {
              setShowSelectSlot(false);
            }}
          />
        }
        destroyTooltipOnHide
        placement="rightTop"
        trigger="click"
        className="dr-cursor-pointer"
        overlayClassName="popover-p-0"
      >
        <div className="dr-flex dr-items-center justify-between BodyBody2Regular dr-min-h-40 dr-h-40 dr-bg-darwin-touch-neutral-0 dr-border dr-border-darwin-touch-neutral-200 dr-rounded-8 dr-w-full dr-px-11 dr-text-darwin-touch-neutral-1000">
          <div>{`${timeLabel}${mode === MODES_OF_APT.IN_CLINIC ? " | In Clinic" : " | Tele"}`}</div>
          <EditRegularIcon className="dr-w-14 dr-h-14 dr-min-w-14 dr-min-h-14 dr-text-darwin-touch-primary-primary" />
        </div>
      </Popover>
    </div>
  );
};

export default NewAptSelectedTime;
